import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EvironmentAPI } from '../../../../environments/enviroments.api'

@Component({
    selector: 'app-download',
    templateUrl: './download.component.html'
})

export class DownloadComponent implements OnInit {
    public isQA: boolean 

    constructor (
        private route: ActivatedRoute
    ) {
        this.detectPlataform()
    }

    ngOnInit(): void {

    }

    detectPlataform (): void { 
        console.log('entrou aqui')
       return this.links()
    }

    links () {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;
        
        if (macosPlatforms.indexOf(platform) !== -1) {
            document.location.href = EvironmentAPI.download_app_ios
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            document.location.href = EvironmentAPI.download_app_ios
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            document.location.href = EvironmentAPI.download_app_android
        } else if (/Android/.test(userAgent)) {
            document.location.href = EvironmentAPI.download_app_android
        } else if (!os && /Linux/.test(platform)) {
            document.location.href = EvironmentAPI.download_app_android
            os = 'Linux';
        }
    }
}